import { supabase } from "../../supabaseClient";
import packageJson from "../../../package.json";

// Временный verbose-режим диагностики авторизации (период расследования).
// Отключается флагом REACT_APP_AUTH_DIAGNOSTICS_VERBOSE=false в .env.
const VERBOSE = process.env.REACT_APP_AUTH_DIAGNOSTICS_VERBOSE === "true";

const getDeviceInfo = () => {
  if (typeof window === "undefined") return null;
  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "";
  const standalone =
    window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
  return {
    ua: ua.slice(0, 500),
    platform: platform.slice(0, 200),
    standalone,
    online: navigator.onLine,
    visibility: document.visibilityState,
    viewport: window.innerWidth + "x" + window.innerHeight,
    connection: navigator.connection
      ? {
          effectiveType: navigator.connection.effectiveType,
          rtt: navigator.connection.rtt,
        }
      : null,
  };
};

/**
 * Записать диагностическое событие авторизации (fire-and-forget, никогда не блокирует вход).
 */
export const recordAuthDiagnostic = ({
  attemptId,
  email,
  stage,
  status,
  errorCode,
  httpStatus,
  latencyMs,
  pagePath,
  requestId,
  meta = {},
}) => {
  if (!VERBOSE) return;
  if (!attemptId || !stage || !status) return;

  const device = getDeviceInfo();
  const payload = {
    p_attempt_id: attemptId,
    p_email: email || null,
    p_stage: stage,
    p_status: status,
    p_error_code: errorCode || null,
    p_http_status: httpStatus ?? null,
    p_latency_ms: latencyMs ?? null,
    p_client_version: packageJson.version,
    p_user_agent: device?.ua || null,
    p_device_info: device ? JSON.stringify(device).slice(0, 500) : null,
    p_page_path:
      pagePath || (typeof window !== "undefined" ? window.location.pathname : null),
    p_request_id: requestId || null,
    p_meta: meta || {},
  };

  try {
    void supabase.rpc("record_auth_diagnostic_event", payload).then(({ error }) => {
      if (error) {
        // Тихий сбой — диагностика не должна ломать вход
      }
    });
  } catch (e) {
    // Тихий сбой
  }
};

export default recordAuthDiagnostic;
